import React, {useState, useEffect} from 'react';
import {times} from '../json/times'
import timezones from '../json/timezones.json'
import { Autocomplete, TextField, Typography} from '@mui/material';
import moment from 'moment';
import countryCodes from "../json/countryCodes.json";

export default function TimeSlot({time, timezone, setTime, day, slot, defaults}) {
    const [error, setError] = useState(false);
    const arr = timezones.map(zone => zone.text);
    const [timezoneName, setTimezoneName] = useState(null);
    const [timeSlot, setTimeSlot] = useState(null);


    useEffect(() => {
        let dayInt = -1;
        switch (day) {
            case "Mon":
                dayInt = 0
                break
            case "Tue":
                dayInt = 1
                break
            case "Wed":
                dayInt = 2
                break
            case "Thu":
                dayInt = 3
                break
        }
        let timezone = ""
        let time = ""
        if (dayInt >= 0) {
            time = defaults[dayInt].slots[slot].time
            timezone = defaults[dayInt].slots[slot].timezone
        }
        if (time !== "" && time !== undefined && time !== null) {
            setTimeSlot(time)
        } else {
            setTimeSlot("")
        }
        if (timezone !== "" && timezone !== undefined && timezone !== null) {
            setTimezoneName(timezone)
        } else {
            let zone = Intl.DateTimeFormat().resolvedOptions().timeZone
            let timezoneName = "(UTC-05:00) Eastern Time (US & Canada)"
            for (let i = 0; i < timezones.length; i++) {
                let zoneNames = timezones[i].utc
                for (let j = 0; j < zoneNames.length; j++) {
                    if (zone === zoneNames[j]) {
                        timezoneName = timezones[i].text
                    }
                }
            }
            setTimezoneName(timezoneName)
            setTime(timezoneName, day, slot, "timezone")
        }
    }, []);

    return (
        <div>
            {timezoneName ?
                <div className='time-slot-box'>
                    <div className='row-center'>
                        <Autocomplete
                            sx={{mx:1}}
                            fullWidth
                            options={times}
                            disableClearable
                            getOptionLabel={(option) => option}
                            onChange={(newValue) => setTime(newValue.target.textContent, day, slot, "time")}
                            defaultValue={timeSlot}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    error={error}
                                    variant="outlined"
                                    placeholder={"Time"}
                                    size="small"
                                />
                            )}
                        />
                        <Autocomplete
                            sx={{mx:1}}
                            fullWidth
                            options={arr}
                            disableClearable
                            getOptionLabel={(option) => option}
                            onChange={(newValue) => setTime(newValue.target.textContent, day, slot, "timezone")}
                            defaultValue={timezoneName}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    error={error}
                                    variant="outlined"
                                    placeholder={"Time Zone"}
                                    size="small"
                                />
                            )}
                        />
                    </div>
                    <Typography sx={{mx:1}} className="font-12 error-message">
                            {error? "Start time must be before end time" : ""}
                    </Typography>
                </div>
                : null
            }
        </div>
    );
}